import {Injectable} from '@angular/core';
import {ProductModel} from '../../api/entity/product.model';
import {ProductRepository} from './ngrx-data/product.repository';
import {ProductDataServiceAdapter} from './ngrx-data/productDataService.adapter';
import {AbstractFindOneByIdService} from '../../../core/service/v2/service/findone/abstractFindOneById.service';

@Injectable()
export class ProductFindOneByIdService extends AbstractFindOneByIdService<ProductModel, ProductModel> {

    constructor(repository: ProductRepository, dataServiceAdapter: ProductDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
